module.exports = __webpack_public_path__ + "static/media/star-formation.eae41540.svg";